import { Module } from 'vuex';
import { SET_PRIVILEGES, SET_USER_CUSTOMER } from './actions';
import { getUserPrivileges, isCustomer } from '../shared/domain/functions/storage-functions';
import { Daycohost } from '../shared/domain/constants/constants';

const app: Module<any, any> = {
    namespaced: true,
    state: {
        metadata: {},
        customer: {},
        privileges: [],
    },
    getters: {
        getPrivilege: state => (privilege: number) => {
            let privilegeFound;

            if (state.privileges.length > 0) {
                privilegeFound = state.privileges.find(
                    element => element.privilege.resource.id === privilege,
                );
            } else {
                const privileges = getUserPrivileges();
                privilegeFound = privileges.find(
                    element => element.privilege.resource.id === privilege,
                );
            }

            if (privilegeFound) {
                return true;
            }

            return false;
        },
        isCustomer(state) {
            if (state.customer.id) {
                return state.customer.id !== Daycohost.id;
            } else {
                return isCustomer();
            }
        },
    },
    mutations: {
        [SET_PRIVILEGES](state, payload) {
            state.privileges = payload;
        },
        [SET_USER_CUSTOMER](state, payload) {
            state.customer = payload;
        },
    },
    actions: {
        [SET_PRIVILEGES]({ commit }, payload) {
            commit('SET_PRIVILEGES', payload);
        },
        [SET_USER_CUSTOMER]({ commit }, payload) {
            commit('SET_USER_CUSTOMER', payload);
        },
    },
};

export default app;
